import { UsersCard } from "./Settings.js";

/** 계정·권한 — 가입은 없다. 대표가 여기서만 계정을 만든다 (harness/SECURITY.md §1) */
export function Users() {
  return (
    <>
      <div className="admin-head">
        <span className="navicon" aria-hidden="true">♟</span>
        <div>
          <h1>계정·권한</h1>
          <p className="page-desc" style={{ margin: 0 }}>
            새 계정은 만든 사람과 같은 스코프를 받습니다. 자기보다 넓게 보는 계정은 만들 수 없습니다.
          </p>
        </div>
      </div>
      <UsersCard />
    </>
  );
}
